import Components from './../Component';

export default class Tabs extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    this.element = element;
    this.tabs = element.querySelectorAll('a');
    this.activeTab = element.querySelector('a.active');

    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].addEventListener("click", this.toggle.bind(this), false);
    }

  }

  toggle(e) {

    e.preventDefault();
    if(e.target !== this.activeTab) {

      this.activeTab.classList.remove('active');
      let currentActiveContent = this.activeTab.getAttribute('href').split('#')[1];
      document.querySelector('#'+currentActiveContent).classList.remove('active');
      this.activeTab = e.target;
      currentActiveContent = this.activeTab.getAttribute('href').split('#')[1];
      this.activeTab.classList.add('active');
      document.querySelector('#'+currentActiveContent).classList.add('active');


      let customEvent = new CustomEvent("tabChanged", {
        detail: {
          mode: this.activeTab.getAttribute('href').split('#')[1]
        }
      });
      document.dispatchEvent(customEvent);

    }

  }
}
